let prefix = 'fas';
let iconName = 'register-asahi';
let width = 512;
let height = 512;
let ligatures = [];
let unicode = 'f0000';
let svgPathData = 'M 191.5715,14.849737 A 110.85307,110.85307 0 0 0 80.731209,125.69002 110.85307,110.85307 0 0 0 191.5715,236.55797 110.85307,110.85307 0 0 0 302.43946,125.69002 110.85307,110.85307 0 0 0 191.5715,14.849737 Z M 398.1966,115.00728 v 79.73305 h -79.2349 v 33.0722 h 79.2349 v 80.20352 h 34.04084 V 227.81253 H 511.5 v -33.0722 H 432.23744 V 115.00728 Z M 111.34029,275.44202 c -61.260912,0 -110.8402875,49.6071 -110.8402875,110.86796 0,61.26093 49.5793755,110.84028 110.8402875,110.84028 H 271.8027 c 61.26092,0 110.84028,-49.57935 110.84028,-110.84028 0,-61.26086 -49.57937,-110.86796 -110.84028,-110.86796 z';

export default {
    prefix: prefix,
    iconName: iconName,
    icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
    ]
}